<div class="col-md-4" [formGroup]="invoiceForm">
    <label class="form-label fw-bold required" for="">
        Client Details
        @if(canAddClient && showSaveClient()){
            <span class="fw-normal fw-bold">(
                    <input type="checkbox" 
                        class="form-check-input me-1" 
                        formControlName="saveClientData" 
                        [checked]="invoiceForm.get('saveClientData')?.value" />Save)
            </span>
        }   
    </label>

    @if(canAddClient){
        <button type="button" class="btn btn-link" (click)="addClientDetails()">
            Add Client <i class="bi bi-plus-square-fill"></i>
        </button>
    }@else {
        <button type="button" class="btn btn-link-primary" (click)="onPremiumAddClientClick()">
            Add Client <i class="bi bi-star-fill"></i>
        </button>
    }

    <!-- Dropdown with clients list if user have more than one clients-->
    @if(clients.length > 0){
        <select #clientSelect class="form-select mb-2" (change)="onClientSelect($event)">
            <option value="">Select Existing Client</option>
            @for(client of clients; track client.id){
                <option value="{{ client.id }}" selected="{{ client.id?.toString() === selectedClientId }}">
                    {{ client.name }}
                </option>
            }
        </select>
    }

    @if(showClientForm()){
        <input type="text" class="form-control mb-1" placeholder="Client Name*" formControlName="clientName"
            [class.is-invalid]="invoiceForm.get('clientName')?.invalid && invoiceForm.get('clientName')?.touched"
            [attr.title]="invoiceForm.get('clientName')?.hasError('required') && invoiceForm.get('clientName')?.touched ? 'Client Name is required' : null"
            data-bs-toggle="tooltip">

        <input type="text" class="form-control mb-1" placeholder="Address*" formControlName="clientAddress"
            [class.is-invalid]="invoiceForm.get('clientAddress')?.invalid && invoiceForm.get('clientAddress')?.touched"
            [attr.title]="invoiceForm.get('clientAddress')?.hasError('required') && invoiceForm.get('clientAddress')?.touched ? 'Client Address is required' : null"
            data-bs-toggle="tooltip" >

        <input type="text" class="form-control mb-1" placeholder="City*" formControlName="clientCity"
            [class.is-invalid]="invoiceForm.get('clientCity')?.invalid && invoiceForm.get('clientCity')?.touched"
            [attr.title]="invoiceForm.get('clientCity')?.hasError('required') && invoiceForm.get('clientCity')?.touched ? 'Client City is required' : null"
            data-bs-toggle="tooltip">

        <input type="text" class="form-control mb-1" placeholder="Province/State*" formControlName="clientProvince"
            [class.is-invalid]="invoiceForm.get('clientProvince')?.invalid && invoiceForm.get('clientProvince')?.touched"
            [attr.title]="invoiceForm.get('clientProvince')?.hasError('required') && invoiceForm.get('clientProvince')?.touched ? 'Client Province is required' : null"
            data-bs-toggle="tooltip">

        <input type="text" class="form-control mb-1" placeholder="Postal/Zip Code*" formControlName="clientPostalCode"
            [class.is-invalid]="invoiceForm.get('clientPostalCode')?.invalid && invoiceForm.get('clientPostalCode')?.touched"
            [attr.title]="invoiceForm.get('clientPostalCode')?.hasError('required') && invoiceForm.get('clientPostalCode')?.touched ? 'Client Postal Code is required' : null"
            data-bs-toggle="tooltip">

        <select class="form-select mb-1" formControlName="clientCountry"
            [class.is-invalid]="invoiceForm.get('clientCountry')?.invalid && invoiceForm.get('clientCountry')?.touched"
            [attr.title]="invoiceForm.get('clientCountry')?.hasError('required') && invoiceForm.get('clientCountry')?.touched ? 'Client Country is required' : null"
            data-bs-toggle="tooltip">

            <option value="">Select Country</option>
            @for (country of countries; track country) {
                <option [value]="country">{{ country }}</option>
            }

        </select>
    }
</div>